<template>
  <v-layout
    class="searchInput"
    wrap
    grow
  >
    <v-flex
      md6
      grow
      px-1
    >
      <label class="cmr-book-form-label">Customer Name</label>
      <v-chip
        class="ml-1 mr-1"
        v-if="bookingForm.user.name != '' && bookingForm.user.vip_customer && bookingForm.user.id != ''"
        x-small
        :color="'#E0C6FF'"
        text-color="white"
      >
        VIP
        <v-icon right x-small>
          mdi-star
        </v-icon>
      </v-chip>
      <v-chip
        v-if="!showBusinessUser && !showBusinessCustomerDetails"
        x-small
        elevation="0"
        color="#003A8C"
        class="small-icon-bg ml-1"
      >
        <span class="white--text pax-pill"
              @click="toggleBusinessUser"
        >
          Lead Pax
          <v-icon
            small
            color="white"
            style="margin-bottom: 3px"
          >
            mdi-account
          </v-icon>
        </span>
      </v-chip>
      <v-btn
        v-if="showBusinessUser || showBusinessCustomerDetails"
        x-small
        fab
        elevation="0"
        color="red lighten-2"
        class="small-icon-bg"
      >
        <v-icon
          small
          color="white"
          @click="toggleBusinessUser"
        >
          visibility_off
        </v-icon>
      </v-btn>

      <SimpleSearchInput
        v-model="bookingForm.user.name"
        :loading="loading"
        :customer-selected="customerSelectedName"
        :lookup="lookupByName"
        :customer-list="customerListName"
        :input-changed="nameChanged"
        :number-changed="numberChanged"
        item-text="name"
        :error="bookingForm.errors.name"
        @input="customerSelectedName"
        :enabled="true"
        :append-icon="
          bookingForm.user != null && bookingForm.user.locked_out == true
            ? 'lock'
            : null
        "
      />
    </v-flex>
    <v-flex
      md6
      grow
    >
      <v-layout
        class="flex-nowrap "
      >
        <v-flex grow>
          <label class="cmr-book-form-label">Contact No.</label>
          <a
            v-if="bookingForm.booking.state != null"
            :href="'tel:' + formatNumber(bookingForm.user.contact_number)"
          >
            <v-btn
              x-small
              fab
              elevation="0"
              color="blue lighten-5"
              class="small-icon-bg"
            >
              <v-icon
                small
                color="blue lighten-2"
              >phone</v-icon>
            </v-btn>
          </a>
          <SimpleSearchInput
            v-model="bookingForm.user.contact_number"
            :loading="loading"
            :customer-selected="customerSelectedNumber"
            :lookup="lookupByNumber"
            :input-changed="numberChanged"
            :customer-list="customerListNumber"
            item-text="contact_number"
            :error="bookingForm.errors.contact_number"
            :enabled="true"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex pl-1 v-if="bookingForm.user.id == '' && bookingForm.user.name">
      <v-checkbox
        dense
        v-model="bookingForm.user.vip_customer"
        :label="'VIP Customer'"
      ></v-checkbox>
    </v-flex>
    <v-flex
      v-if="
        !userIsBusiness() &&
          bookingForm.user.notes != null &&
          bookingForm.user.notes.length > 0
      "
      lg7
      pa-1
      pt-2
    >
      <SimpleTextAreaInput
        v-if="
          bookingForm.user.contact_number != null &&
            bookingForm.user.contact_number != ''
        "
        v-model="bookingForm.user.notes"
        label="Customer Account Notes"
        @input="changeUserNotes"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleSearchInput from "@/components/widget/input/SimpleSearchInput.vue";
import SimpleNumberInput from "@/components/widget/input/SimpleNumberInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

import { replaceStart } from "@/components/util/PhoneNumbers.js";

export default {
  name: "CustomerSearchInputV2",
  components: {
    BookingDateInput,
    SimpleSearchInput,
    SelectableInput,
    SimpleNumberInput,
    SimpleTextAreaInput,
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false,
    },
    showBusinessCustomerDetails: {
      type: Boolean,
      default: false,
    },
  },
  computer: {},
  data() {
    return {
      menu: false,
      showBusinessUser: false,
      customerListName: [],
      customerListNumber: [],
      loading: false,
      name: "",
      number: "",
    };
  },
  methods: {
    toggleBusinessUser () {
      this.showBusinessUser = !this.showBusinessUser;
      this.$emit('showBusinessCustomer', this.showBusinessUser )
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
    userIsBusiness: function () {
      console.log("User is business " + this.bookingForm.user.business == true);
      return this.bookingForm.user.business == true;
    },
    changeUserNotes: function (notes) {
      this.bookingForm.user.notes = notes;
    },
    nameChanged: function (name) {
      // console.log("Name " + JSON.stringify(name));
    },
    numberChanged: function (number) {
      // console.log("Number " + number);
    },
    customerSelectedName: function (val) {
      console.log("customer selected " + JSON.stringify(val));

      if (typeof val === "string") {
        this.bookingForm.user.name = val;
        this.bookingForm.clearCustomerId()
        if (val.length > 0) {
          this.bookingForm.errors.name = null;
        }
      } else {
        this.bookingForm.user.name = val.name;
        this.bookingForm.user.contact_number = val.contact_number;
        this.bookingForm.getCustomer(val.contact_number);
      }
    },
    customerSelectedNumber: function (val) {
      console.log("customer selected " + JSON.stringify(val));

      if (typeof val === "string") {
        this.bookingForm.user.contact_number = val;

        this.bookingForm.clearCustomer();

        // clearing customer could remove promocodes etc
        this.bookingForm.getCostEstimate();

        if (val.length > 0) {
          this.bookingForm.errors.contact_number = null;
        }
      } else {
        this.bookingForm.user.name = val.name;
        this.bookingForm.user.contact_number = val.contact_number;
        this.bookingForm.getCustomer(val.contact_number);
      }
    },
    lookupByName: function (val) {
      if (val == null) return;
      if (val.length <= 1) return;

      this.name = val;

      var url = `${this.$store.state.apiUrl}/customer/findByName?name=${val}`;

      var searchCompleted = this.searchCompletedName;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (val == vm.name) {
            searchCompleted(res.data);
          }
        })
        .catch(function (err) {
          console.error(err);
          this.loading = false;
        });
    },
    lookupByNumber: function (val) {
      if (val == null) return;
      if (val.length <= 1) return;

      this.number = val;

      var url = `${this.$store.state.apiUrl}/customer/findByNumber?contact_number=${val}`;

      var searchCompleted = this.searchCompletedNumber;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (val == vm.number) {
            searchCompleted(res.data);
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    searchCompletedName: function (data) {
      this.customerListName = data;

      this.loading = false;
    },
    searchCompletedNumber: function (data) {
      this.customerListNumber = data;

      this.loading = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.small-fab-phone {
  transform: scale(0.7);
  transform-origin: left;
}
</style>
